<!-- Ultra Modern Subscription CTA -->
<div class="relative overflow-hidden rounded-3xl bg-gradient-to-br from-primary-600 via-primary-700 to-primary-900 dark:from-primary-800 dark:via-primary-900 dark:to-gray-900 shadow-2xl hover:shadow-3xl transition-all duration-500 group mx-2 my-4">
  <!-- Animated background effects -->
  <div class="absolute inset-0 opacity-30">
    <div class="absolute top-0 right-0 w-[600px] h-[600px] bg-gradient-to-br from-blue-400/30 to-purple-600/30 rounded-full blur-3xl animate-pulse"></div>
    <div class="absolute bottom-0 left-0 w-[500px] h-[500px] bg-gradient-to-tr from-green-400/20 to-cyan-500/20 rounded-full blur-3xl animate-pulse animation-delay-1000"></div>
  </div>

  <!-- Mesh pattern overlay -->
  <div class="absolute inset-0 opacity-10">
    <svg class="w-full h-full" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <pattern id="grid-subscription" width="32" height="32" patternUnits="userSpaceOnUse">
          <path d="M 32 0 L 0 0 0 32" fill="none" stroke="white" stroke-width="0.5"/>
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#grid-subscription)" />
    </svg>
  </div>

  <!-- Content -->
  <div class="relative z-10 p-6 md:p-8 lg:p-10">
    <!-- Header Section -->
    <div class="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6 mb-8">
      <div class="flex-1">
        <div class="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/20 backdrop-blur-md border border-white/30 mb-4">
          <lucide-icon [name]="iconSparkles" [size]="16" class="text-yellow-300 animate-pulse"></lucide-icon>
          <span class="text-white text-xs font-semibold uppercase tracking-wider">Dostęp płatny</span>
        </div>

        <h2 class="text-4xl md:text-5xl lg:text-6xl font-black text-white mb-4 leading-tight">
          Ekowitryna - Twoje narzędzie do zarządzania odpadami
        </h2>

        <p class="text-white/90 text-lg md:text-xl max-w-3xl leading-relaxed mb-6">
          Możliwość korzystania z naszych modułów kart, raportowania i ewidencji wymaga wykupienia dostępu. Zapraszamy do zapoznania się z naszą ofertą subskrypcji!
        </p>

        <!-- Enhanced Logo Display -->
        <div class="inline-flex items-center gap-4 mb-6">
          <div class="relative group/logo">
            <!-- Glow effect behind logo -->
            <div class="absolute inset-0 bg-gradient-to-r from-white/40 to-primary-200/40 rounded-2xl blur-xl group-hover/logo:blur-2xl transition-all duration-300 scale-110"></div>

            <!-- Logo container -->
            <div class="relative bg-white rounded-2xl p-4 shadow-2xl border-2 border-white/50 group-hover/logo:scale-105 group-hover/logo:shadow-3xl transition-all duration-300">
              <img class="h-14 md:h-16 w-auto" src="https://ekowitryna.pl/wp-content/uploads/2023/02/proeko_logo_ekowitryna_01-e1675433922637.png" alt="Ekowitryna.pl" />
            </div>
          </div>

          <!-- Badge next to logo -->
          <div class="hidden sm:flex flex-col gap-1">
            <div class="flex items-center gap-2 px-3 py-1 rounded-lg bg-white/20 backdrop-blur-md border border-white/30">
              <lucide-icon [name]="iconShield" [size]="14" class="text-green-300"></lucide-icon>
              <span class="text-white text-xs font-semibold">Zaufany partner</span>
            </div>
            <div class="flex items-center gap-2 px-3 py-1 rounded-lg bg-white/20 backdrop-blur-md border border-white/30">
              <lucide-icon [name]="iconUsers" [size]="14" class="text-blue-300"></lucide-icon>
              <span class="text-white text-xs font-semibold">Tysiące klientów</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Eye-catching icon -->
      <div class="flex-shrink-0">
        <div class="relative w-24 h-24 lg:w-32 lg:h-32">
          <div class="absolute inset-0 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-3xl animate-spin-slow opacity-75 blur-xl"></div>
          <div class="relative w-full h-full bg-gradient-to-br from-white to-primary-100 rounded-3xl flex items-center justify-center shadow-2xl transform group-hover:rotate-6 transition-transform duration-500">
            <lucide-icon [name]="iconRecycle" [size]="48" class="text-primary-700"></lucide-icon>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Features Grid -->
    <div class="mb-8">
      <h3 class="text-2xl md:text-3xl font-bold text-white mb-4">Co zyskujesz?</h3>
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-6">
        <!-- Feature: Moduł Kart -->
        <div class="group/card relative overflow-hidden rounded-2xl bg-white/10 backdrop-blur-md border border-white/20 p-5 hover:bg-white/15 hover:border-white/40 hover:scale-[1.02] transition-all duration-300 cursor-pointer">
          <div class="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-blue-400/20 to-transparent rounded-full blur-2xl group-hover/card:scale-150 transition-transform duration-500"></div>
          <div class="relative">
            <div class="flex items-center gap-3 mb-3">
              <div class="flex-shrink-0 w-12 h-12 rounded-xl bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center shadow-lg">
                <lucide-icon [name]="iconFileText" [size]="24" class="text-white"></lucide-icon>
              </div>
              <h4 class="text-white font-bold text-lg">Moduł Kart</h4>
            </div>
            <ul class="text-white/90 text-sm space-y-2">
              <li class="flex items-start gap-2">
                <lucide-icon [name]="iconCheck" [size]="16" class="text-blue-300 flex-shrink-0 mt-0.5"></lucide-icon>
                <span>Zarządzanie kartami w rolach: przekazujący, przejmujący, transportujący</span>
              </li>
              <li class="flex items-start gap-2">
                <lucide-icon [name]="iconCheck" [size]="16" class="text-blue-300 flex-shrink-0 mt-0.5"></lucide-icon>
                <span>Masowa zmiana statusów kart</span>
              </li>
              <li class="flex items-start gap-2">
                <lucide-icon [name]="iconCheck" [size]="16" class="text-blue-300 flex-shrink-0 mt-0.5"></lucide-icon>
                <span>Tworzenie i kopiowanie kart odpadów</span>
              </li>
            </ul>
          </div>
        </div>

        <!-- Feature: Moduł Raportowy -->
        <div class="group/card relative overflow-hidden rounded-2xl bg-white/10 backdrop-blur-md border border-white/20 p-5 hover:bg-white/15 hover:border-white/40 hover:scale-[1.02] transition-all duration-300 cursor-pointer">
          <div class="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-purple-400/20 to-transparent rounded-full blur-2xl group-hover/card:scale-150 transition-transform duration-500"></div>
          <div class="relative">
            <div class="flex items-center gap-3 mb-3">
              <div class="flex-shrink-0 w-12 h-12 rounded-xl bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center shadow-lg">
                <lucide-icon [name]="iconBarChart" [size]="24" class="text-white"></lucide-icon>
              </div>
              <h4 class="text-white font-bold text-lg">Moduł Raportowy</h4>
            </div>
            <ul class="text-white/90 text-sm space-y-2">
              <li class="flex items-start gap-2">
                <lucide-icon [name]="iconCheck" [size]="16" class="text-purple-300 flex-shrink-0 mt-0.5"></lucide-icon>
                <span>Eksport całej ewidencji do pliku CSV</span>
              </li>
              <li class="flex items-start gap-2">
                <lucide-icon [name]="iconCheck" [size]="16" class="text-purple-300 flex-shrink-0 mt-0.5"></lucide-icon>
                <span>Analiza i weryfikacja danych</span>
              </li>
              <li class="flex items-start gap-2">
                <lucide-icon [name]="iconCheck" [size]="16" class="text-purple-300 flex-shrink-0 mt-0.5"></lucide-icon>
                <span>Pomoc w sprawozdaniach rocznych</span>
              </li>
            </ul>
          </div>
        </div>

        <!-- Feature: Moduł Ewidencji -->
        <div class="group/card relative overflow-hidden rounded-2xl bg-white/10 backdrop-blur-md border border-white/20 p-5 hover:bg-white/15 hover:border-white/40 hover:scale-[1.02] transition-all duration-300 cursor-pointer">
          <div class="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-green-400/20 to-transparent rounded-full blur-2xl group-hover/card:scale-150 transition-transform duration-500"></div>
          <div class="relative">
            <div class="flex items-center gap-3 mb-3">
              <div class="flex-shrink-0 w-12 h-12 rounded-xl bg-gradient-to-br from-green-400 to-green-600 flex items-center justify-center shadow-lg">
                <lucide-icon [name]="iconDatabase" [size]="24" class="text-white"></lucide-icon>
              </div>
              <h4 class="text-white font-bold text-lg">Moduł Ewidencji</h4>
            </div>
            <ul class="text-white/90 text-sm space-y-2">
              <li class="flex items-start gap-2">
                <lucide-icon [name]="iconCheck" [size]="16" class="text-green-300 flex-shrink-0 mt-0.5"></lucide-icon>
                <span>Wpis jednocześnie w wielu sekcjach</span>
              </li>
              <li class="flex items-start gap-2">
                <lucide-icon [name]="iconCheck" [size]="16" class="text-green-300 flex-shrink-0 mt-0.5"></lucide-icon>
                <span>Dodawanie wpisów do KEO i KEOK</span>
              </li>
              <li class="flex items-start gap-2">
                <lucide-icon [name]="iconCheck" [size]="16" class="text-green-300 flex-shrink-0 mt-0.5"></lucide-icon>
                <span>Automatyczny rozkład masy odpadu</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Additional Benefits -->
    <div class="mb-8">
      <h3 class="text-2xl md:text-3xl font-bold text-white mb-4">Dodatkowe korzyści</h3>
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <!-- Benefit 1 -->
        <div class="group/card relative overflow-hidden rounded-2xl bg-white/10 backdrop-blur-md border border-white/20 p-4 hover:bg-white/15 hover:border-white/40 hover:scale-[1.02] transition-all duration-300 cursor-pointer">
          <div class="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-orange-400/20 to-transparent rounded-full blur-2xl group-hover/card:scale-150 transition-transform duration-500"></div>
          <div class="relative flex items-center gap-3">
            <div class="flex-shrink-0 w-12 h-12 rounded-xl bg-gradient-to-br from-orange-400 to-orange-600 flex items-center justify-center shadow-lg">
              <lucide-icon [name]="iconShield" [size]="24" class="text-white"></lucide-icon>
            </div>
            <div class="flex-1 min-w-0">
              <p class="text-white font-bold text-sm leading-tight">Wsparcie w nauce i posługiwaniu się BDO, KOBiZE i innymi systemami</p>
            </div>
          </div>
        </div>

        <!-- Benefit 2 -->
        <div class="group/card relative overflow-hidden rounded-2xl bg-white/10 backdrop-blur-md border border-white/20 p-4 hover:bg-white/15 hover:border-white/40 hover:scale-[1.02] transition-all duration-300 cursor-pointer">
          <div class="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-cyan-400/20 to-transparent rounded-full blur-2xl group-hover/card:scale-150 transition-transform duration-500"></div>
          <div class="relative flex items-center gap-3">
            <div class="flex-shrink-0 w-12 h-12 rounded-xl bg-gradient-to-br from-cyan-400 to-cyan-600 flex items-center justify-center shadow-lg">
              <lucide-icon [name]="iconUsers" [size]="24" class="text-white"></lucide-icon>
            </div>
            <div class="flex-1 min-w-0">
              <p class="text-white font-bold text-sm leading-tight">Zamknięte forum GOZ - zadaj pytanie ekspertom</p>
            </div>
          </div>
        </div>

        <!-- Benefit 3 -->
        <div class="group/card relative overflow-hidden rounded-2xl bg-white/10 backdrop-blur-md border border-white/20 p-4 hover:bg-white/15 hover:border-white/40 hover:scale-[1.02] transition-all duration-300 cursor-pointer">
          <div class="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-pink-400/20 to-transparent rounded-full blur-2xl group-hover/card:scale-150 transition-transform duration-500"></div>
          <div class="relative flex items-center gap-3">
            <div class="flex-shrink-0 w-12 h-12 rounded-xl bg-gradient-to-br from-pink-400 to-pink-600 flex items-center justify-center shadow-lg">
              <lucide-icon [name]="iconTrendingUp" [size]="24" class="text-white"></lucide-icon>
            </div>
            <div class="flex-1 min-w-0">
              <p class="text-white font-bold text-sm leading-tight">Dostęp do webinarów i szkoleń</p>
            </div>
          </div>
        </div>

        <!-- Benefit 4 -->
        <div class="group/card relative overflow-hidden rounded-2xl bg-white/10 backdrop-blur-md border border-white/20 p-4 hover:bg-white/15 hover:border-white/40 hover:scale-[1.02] transition-all duration-300 cursor-pointer">
          <div class="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-indigo-400/20 to-transparent rounded-full blur-2xl group-hover/card:scale-150 transition-transform duration-500"></div>
          <div class="relative flex items-center gap-3">
            <div class="flex-shrink-0 w-12 h-12 rounded-xl bg-gradient-to-br from-indigo-400 to-indigo-600 flex items-center justify-center shadow-lg">
              <lucide-icon [name]="iconZap" [size]="24" class="text-white"></lucide-icon>
            </div>
            <div class="flex-1 min-w-0">
              <p class="text-white font-bold text-sm leading-tight">Szerokie rabaty na usługi bezpośrednie dla stałych subskrybentów</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Value Proposition -->
    <div class="mb-8">
      <div class="relative overflow-hidden rounded-2xl bg-gradient-to-br from-yellow-400/20 to-orange-500/20 backdrop-blur-md border-2 border-yellow-400/50 p-6">
        <div class="absolute inset-0 bg-gradient-to-br from-yellow-400/10 to-orange-500/10 animate-pulse"></div>
        <div class="relative">
          <div class="flex items-start gap-4">
            <div class="flex-shrink-0 w-16 h-16 rounded-xl bg-gradient-to-br from-yellow-400 to-orange-500 flex items-center justify-center shadow-lg animate-bounce-slow">
              <lucide-icon [name]="iconSparkles" [size]="32" class="text-white"></lucide-icon>
            </div>
            <div class="flex-1">
              <h3 class="text-2xl font-bold text-white mb-2">Zyskaj nie tylko narzędzie, ale też wsparcie!</h3>
              <p class="text-white/90 text-lg leading-relaxed">
                Dołącz do naszej społeczności i przekonaj się, jak wiele możesz zyskać. Zaoszczędź czas, uniknij błędów i miej pewność, że Twoja ewidencja odpadów jest zgodna z wymaganiami prawnymi!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CTA Buttons -->
    <div class="flex flex-col sm:flex-row gap-4 mb-6">
      <button
        (click)="openBuyNow()"
        class="group/btn relative overflow-hidden flex-1 px-8 py-4 rounded-2xl bg-white text-primary-700 font-bold text-lg shadow-2xl hover:shadow-3xl transform hover:-translate-y-1 transition-all duration-300">
        <div class="absolute inset-0 bg-gradient-to-r from-primary-100 to-primary-200 opacity-0 group-hover/btn:opacity-100 transition-opacity duration-300"></div>
        <div class="relative flex items-center justify-center gap-3">
          <lucide-icon [name]="iconShoppingCart" [size]="24" class="group-hover/btn:scale-110 transition-transform"></lucide-icon>
          <span>Kup teraz</span>
          <i class="pi pi-arrow-right text-sm group-hover/btn:translate-x-1 transition-transform"></i>
        </div>
      </button>

      <button
        (click)="openMoreInfo()"
        class="group/btn flex-1 sm:flex-none px-8 py-4 rounded-2xl bg-white/10 backdrop-blur-md border-2 border-white/30 text-white font-semibold text-lg hover:bg-white/20 hover:border-white/50 transition-all duration-300">
        <div class="flex items-center justify-center gap-3">
          <i class="pi pi-external-link text-sm"></i>
          <span>Więcej informacji</span>
        </div>
      </button>
    </div>

    <!-- Contact Info -->
    <div class="text-center text-white/80 text-sm">
      <p>
        Masz pytania? Odwiedź <a class="text-yellow-300 hover:text-yellow-200 underline transition-colors" href="https://ekowitryna.pl" target="_blank" rel="noopener">ekowitryna.pl</a> lub napisz na
        <a class="text-yellow-300 hover:text-yellow-200 underline transition-colors" href="mailto:kontakt@ekowitryna.pl">kontakt&#64;ekowitryna.pl</a>
      </p>
    </div>
  </div>
</div>
